import React, { useMemo, useState } from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { loadBracket, loadTeams, loadMatches } from '../utils/storage';
import '../components/CommonButton.css'; // Importa stili comuni per coerenza
import { calcolaClassificaFinale } from '../utils/finalRanking';
import { MedalIcon } from '../components/FencingIcons';

const FinalRankingPage = () => {
  // const navigate = useNavigate();

  // Stati per il collasso delle classifiche (default: classifiche collassate)
  const [showPoolRanking, setShowPoolRanking] = useState(false);
  const [showFinalRanking, setShowFinalRanking] = useState(false);



  // Recupera il tipo di competizione
  const competitionType = useMemo(() => localStorage.getItem('competitionType') || 'individual', []);
  const isIndividual = competitionType === 'individual';

  // Recupera standings dal girone (come in RoundRobinTable)
  const teams = useMemo(() => loadTeams() || [], []);
  const matches = useMemo(() => loadMatches() || [], []);
  const standings = useMemo(() => {
    const teamStats = teams.map((team, index) => ({
      id: index,
      name: team.name,
      wins: 0,
      losses: 0,
      pointsScored: 0,
      pointsConceded: 0,
      matchesPlayed: 0,
      members: Array.isArray(team.members) ? team.members : [],
    }));
    matches.forEach(match => {
      if (match.completed) {
        const teamAIndex = match.teamA;
        const teamBIndex = match.teamB;
        if (teamStats[teamAIndex] === undefined || teamStats[teamBIndex] === undefined) return;

        const sA = Number(match.scoreA) || 0;
        const sB = Number(match.scoreB) || 0;

        teamStats[teamAIndex].pointsScored += sA;
        teamStats[teamAIndex].pointsConceded += sB;
        teamStats[teamBIndex].pointsScored += sB;
        teamStats[teamBIndex].pointsConceded += sA;

        if (sA > sB) {
          teamStats[teamAIndex].wins += 1;
          teamStats[teamBIndex].losses += 1;
        } else if (sB > sA) {
          teamStats[teamBIndex].wins += 1;
          teamStats[teamAIndex].losses += 1;
        }
        teamStats[teamAIndex].matchesPlayed += 1;
        teamStats[teamBIndex].matchesPlayed += 1;
      }
    });
    teamStats.forEach(team => {
      team.pointsDiff = (team.pointsScored || 0) - (team.pointsConceded || 0);
    });
    return [...teamStats].sort((a, b) => {
      const winsA = a.wins || 0;
      const winsB = b.wins || 0;
      if (winsA !== winsB) return winsB - winsA;
      const diffA = a.pointsDiff || 0;
      const diffB = b.pointsDiff || 0;
      if (diffB !== diffA) return diffB - diffA;
      return (b.pointsScored || 0) - (a.pointsScored || 0);
    });
  }, [teams, matches]);

  const bracket = useMemo(() => loadBracket() || [], []);
  const finalRanking = useMemo(() => {
    if (bracket && bracket.length > 0) {
      return calcolaClassificaFinale(standings, bracket);
    }
    return [];
  }, [standings, bracket]);

  // Semplificate le funzioni per i toggle
  const togglePoolRanking = () => setShowPoolRanking(!showPoolRanking);
  const toggleFinalRanking = () => setShowFinalRanking(!showFinalRanking);

  // Se l'accesso è consentito, mostriamo la classifica finale
  return (
    <ScrollView style={[styles.container, { backgroundColor: '#f5f5f5' }]}>
      <View style={{ marginTop: 36, marginBottom: 16 }}>
        <View style={{ alignItems: 'center', justifyContent: 'center' }}>
          <MedalIcon style={{ fontSize: 44, color: '#1976d2', marginBottom: 8 }} />
          <Text style={{ fontSize: 32, fontWeight: 'bold', color: '#1976d2', textAlign: 'center', textShadowColor: '#0001', textShadowOffset: { width: 0, height: 2 }, textShadowRadius: 4 }}>Classifica</Text>
        </View>
        <View style={{ height: 4, backgroundColor: '#1976d2', width: 80, borderRadius: 2, alignSelf: 'center', marginBottom: 18, opacity: 0.18 }} />
      </View>

      {/* Classifica dopo i gironi */}
      <View style={{ marginBottom: 30 }}>
        <TouchableOpacity
          style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}
          onPress={togglePoolRanking}
        >
          <Text style={{ fontSize: 24, fontWeight: 'bold', color: '#FF9800', textAlign: 'center' }}>Classifica dopo i gironi</Text>
          <Text style={{ fontSize: 22, marginLeft: 10, color: '#FF9800' }}>{showPoolRanking ? '▼' : '▶'}</Text>
        </TouchableOpacity>
        <View style={{ height: 3, backgroundColor: '#FF9800', width: 60, borderRadius: 2, alignSelf: 'center', marginBottom: 15, opacity: 0.2 }} />

        {showPoolRanking && (
          <View>
            <View style={[styles.tableHeader, { flexDirection: 'row', backgroundColor: '#FF9800', borderRadius: 12 }]}>
              <Text style={[styles.headerCell, { minWidth: 50 }]}>Pos</Text>
              {!isIndividual && <Text style={[styles.headerCell, { minWidth: 140 }]}>Squadra</Text>}
              {!isIndividual && <Text style={[styles.headerCell, { minWidth: 200, textAlign: 'center' }]}>Partecipanti</Text>}
              {isIndividual && <Text style={[styles.headerCell, { flex: 3 }]}>Atleta</Text>}
              <Text style={[styles.headerCell, { minWidth: 60 }]}>V</Text>
              <Text style={[styles.headerCell, { minWidth: 60 }]}>S</Text>
              <Text style={[styles.headerCell, { minWidth: 60 }]}>+/-</Text>
            </View>

            {standings.map((team, idx) => (
              <View key={`pool-${team.name}-${idx}`} style={{ flexDirection: 'row', alignItems: 'flex-start', borderRadius: 10, backgroundColor: idx % 2 === 0 ? '#f5f5f5' : '#e0e0e0' }}>
                <Text style={[styles.cell, { minWidth: 50, color: '#FF9800', fontWeight: 'bold', fontSize: 16, textAlign: 'center', marginTop: 10 }]}>{idx + 1}</Text>

                {isIndividual ? (
                  <View style={{ flex: 3, flexDirection: 'column', alignItems: 'center', paddingRight: 8, marginTop: 10 }}>
                    <Text style={{ color: '#FF9800', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>{team.name}</Text>
                  </View>
                ) : (
                  <>
                    <View style={{ minWidth: 140, flex: 1, flexDirection: 'column', alignItems: 'flex-end', paddingRight: 8, marginTop: 10 }}>
                      <Text style={{ color: '#FF9800', fontWeight: 'bold', fontSize: 16, textAlign: 'right' }}>{team.name}</Text>
                    </View>
                    <View style={{ minWidth: 200, flex: 2, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                      {Array.isArray(team.members) && team.members.map((m, i) => (
                        <Text key={`pool-member-${m.name}-${i}`} style={{ color: '#FF9800', fontSize: 15, textAlign: 'center' }}>{typeof m === 'object' ? m.name : m}</Text>
                      ))}
                    </View>
                  </>
                )}

                <Text style={[styles.cell, { minWidth: 60, color: '#FF9800', fontSize: 16, textAlign: 'center', marginTop: 10 }]}>{team.wins}</Text>
                <Text style={[styles.cell, { minWidth: 60, color: '#FF9800', fontSize: 16, textAlign: 'center', marginTop: 10 }]}>{team.pointsScored}</Text>
                <Text style={[styles.cell, { minWidth: 60, color: '#FF9800', fontSize: 16, textAlign: 'center', marginTop: 10 }]}>{team.pointsDiff}</Text>
              </View>
            ))}
          </View>
        )}
      </View>

      {/* Classifica finale */}
      <View style={{ marginBottom: 30 }}>
        <TouchableOpacity
          style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginTop: 20, marginBottom: 10 }}
          onPress={toggleFinalRanking}
        >
          <Text style={{ fontSize: 24, fontWeight: 'bold', color: '#1976d2', textAlign: 'center' }}>Classifica dopo eliminazione diretta</Text>
          <Text style={{ fontSize: 22, marginLeft: 10, color: '#1976d2' }}>{showFinalRanking ? '▼' : '▶'}</Text>
        </TouchableOpacity>
        <View style={{ height: 3, backgroundColor: '#1976d2', width: 60, borderRadius: 2, alignSelf: 'center', marginBottom: 15, opacity: 0.2 }} />

        {showFinalRanking && (
          <View>
            <View style={[styles.tableHeader, { flexDirection: 'row', backgroundColor: '#1976d2', borderRadius: 12 }]}>
              <Text style={[styles.headerCell, { minWidth: 50 }]}>Pos</Text>
              {!isIndividual && <Text style={[styles.headerCell, { minWidth: 140 }]}>Squadra</Text>}
              {!isIndividual && <Text style={[styles.headerCell, { minWidth: 200, textAlign: 'center' }]}>Partecipanti</Text>}
              {isIndividual && <Text style={[styles.headerCell, { flex: 3 }]}>Atleta</Text>}
            </View>
            {finalRanking.map((team, idx) => (
              <View key={team.name + idx} style={{ flexDirection: 'row', alignItems: 'flex-start', borderRadius: 10, backgroundColor: idx % 2 === 0 ? '#f5f5f5' : '#e0e0e0' }}>
                <Text style={[styles.cell, { minWidth: 50, color: '#1976d2', fontWeight: 'bold', fontSize: 16, textAlign: 'center', marginTop: 10 }]}>{team.posizione}</Text>
                {isIndividual ? (
                  <View style={{ flex: 3, flexDirection: 'column', alignItems: 'center', paddingRight: 8, marginTop: 10 }}>
                    <Text style={{ color: '#1976d2', fontWeight: 'bold', fontSize: 16, textAlign: 'center' }}>{team.name}</Text>
                  </View>
                ) : (
                  <>
                    <View style={{ minWidth: 140, flex: 1, flexDirection: 'column', alignItems: 'flex-end', paddingRight: 8, marginTop: 10 }}>
                      <Text style={{ color: '#1976d2', fontWeight: 'bold', fontSize: 16, textAlign: 'right' }}>{team.name}</Text>
                    </View>
                    <View style={{ minWidth: 200, flex: 2, flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                      {Array.isArray(team.members) && team.members.map((m, i) => (
                        <Text key={m.name + i} style={{ color: '#1976d2', fontSize: 15, textAlign: 'center' }}>{m.name}</Text>
                      ))}
                    </View>
                  </>
                )}
              </View>
            ))}
          </View>
        )}
      </View>
    </ScrollView>
  );
};

// --- SCANSIONE: Controlla che tutto il testo sia racchiuso in <Text> ---
// Tutte le visualizzazioni di testo sono già racchiuse in <Text> o sono children di <Text>.
// Nessun caso di testo diretto in <View> trovato (controllo manuale su tutte le sezioni di rendering).

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: '#fff',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#1976d2',
    padding: 12,
    borderRadius: 12,
    marginBottom: 4,
  },
  headerCell: {
    color: 'white',
    fontWeight: 'bold',
    flex: 1,
    textAlign: 'center',
    borderRadius: 8,
    overflow: 'hidden',
  },
  cell: {
    flex: 1,
    textAlign: 'center',
    borderRadius: 8,
    overflow: 'hidden',
  },
});

export default FinalRankingPage;
